export class TBar {
  topText: string;
  topX: string;
  topY: string;

  barX: string;
  barY: string;
  barHeigth: string;
  barWidth: string;

  bottomText: string;
  bottomX: string;
  bottomY: string;
}

export class TBarParams {
  percent: number;
  text: string;
}

export class TwoBarParams {
  percentageAppropriateUnderPlanned: number;
  appropiateValue: number;
  plannedValue: number;
}

export class TTwoBars extends TBar {
  colorFill: string;
}
